(() => {
  let dispose;
  function init() {
    if (dispose) dispose();
    const pane = document.getElementById('CatalogBrowser');
    if (!pane) return;
    const launches = [...document.querySelectorAll('.catalog-launch')], close = pane.querySelector('.catalog-close'), shade = document.querySelector('.catalog-backdrop');
    const body = document.querySelector('.storefront-body'), mobile = matchMedia('(max-width:1000px)');
    const controller = new AbortController(), on = (el, event, fn) => el.addEventListener(event, fn, {signal:controller.signal});
    let expanded = false, previous;
    const experimentKey = 'killin-catalog-control-v1', variants = ['floating_button','left_tab'];
    let variant = variants[Math.random() < .5 ? 0 : 1];
    const impressions = new Set();
    function analyticsAllowed(){try{return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;}catch(_){return false;}}
    // No tracking storage is read/written until analytics consent. Without it,
    // the functional layout choice lasts only for this page.
    if(analyticsAllowed())try{const savedVariant=sessionStorage.getItem(experimentKey);if(variants.includes(savedVariant))variant=savedVariant;}catch(_){}
    function showControl(){
      launches.forEach(button=>button.hidden=button.dataset.catalogControl!==variant);
      document.documentElement.dataset.catalogControl=mobile.matches?variant:'desktop_sidebar';
    }
    function reportExposure(){
      if(!analyticsAllowed()){impressions.clear();return;}
      try{sessionStorage.setItem(experimentKey,variant);}catch(_){}
      if(!mobile.matches||expanded||document.hidden||impressions.has(variant)||!window.KillinBehavior?.enabled)return;
      impressions.add(variant);
      window.KillinBehavior.record('catalog',{action:'control_impression',experiment:'catalog_control_v1',control:variant});
    }
    document.documentElement.classList.add('catalog-enhanced');
    close.hidden = false;showControl();
    const storageKey = 'killin-catalog-v1';
    let saved = {};
    try { saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}'); } catch (_) {}
    pane.querySelectorAll('details[data-catalog-branch]').forEach(branch => {
      const key = branch.dataset.catalogBranch;
      if (typeof saved[key] === 'boolean') branch.open = saved[key];
      on(branch, 'toggle', () => { saved[key] = branch.open; try { sessionStorage.setItem(storageKey, JSON.stringify(saved)); } catch (_) {} });
    });
    on(window, 'pagehide', () => {
      pane.querySelectorAll('details[data-catalog-branch]').forEach(branch => { saved[branch.dataset.catalogBranch] = branch.open; });
      try { sessionStorage.setItem(storageKey, JSON.stringify(saved)); } catch (_) {}
    });
    pane.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.href);
      const current = new URL(location.href);
      const normalized = params => JSON.stringify([...params.entries()].sort());
      const sameQuery = url.searchParams.get('view') === 'pokedex'
        ? current.searchParams.get('view') === 'pokedex' && url.searchParams.get('q') === current.searchParams.get('q')
        : normalized(url.searchParams) === normalized(current.searchParams);
      if (url.origin === location.origin && url.pathname === location.pathname && sameQuery) {
        link.setAttribute('aria-current','page');
        let parent = link.parentElement;
        while (parent && parent !== pane) { if (parent.tagName === 'DETAILS') parent.open = true; parent = parent.parentElement; }
      }
    });
    function setOpen(value, restore = true, opener) {
      expanded = value && mobile.matches;
      document.documentElement.classList.toggle('catalog-open', expanded);
      launches.forEach(button=>button.setAttribute('aria-expanded', String(expanded)));
      shade.hidden = !expanded;
      body.inert = expanded;
      pane.inert = mobile.matches && !expanded;
      if (mobile.matches) pane.setAttribute('aria-hidden', String(!expanded)); else pane.removeAttribute('aria-hidden');
      if (expanded) {
        previous = opener || launches.find(button=>!button.hidden); pane.setAttribute('role','dialog'); pane.setAttribute('aria-modal','true');
        requestAnimationFrame(() => { if (expanded) close.focus(); });
        // Chrome can defer focus while the drawer is transitioning from hidden.
        setTimeout(() => { if (expanded && !pane.contains(document.activeElement)) close.focus(); }, 200);
      }
      else { pane.removeAttribute('role'); pane.removeAttribute('aria-modal'); if (restore && previous) previous.focus(); reportExposure(); }
    }
    launches.forEach(button=>on(button,'click',() => setOpen(!expanded,true,button))); on(close,'click',() => setOpen(false)); on(shade,'click',() => setOpen(false));
    on(document,'keydown',event => {
      if (!expanded) return;
      if (event.key === 'Escape') { event.preventDefault(); setOpen(false); }
      if (event.key === 'Tab') {
        const focusable = [...pane.querySelectorAll('a[href],button,input,summary')].filter(el => el.getClientRects().length && !el.disabled);
        const first = focusable[0], last = focusable[focusable.length-1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    on(pane,'click',event => { if (event.target.closest('a[href]') && mobile.matches) setOpen(false); });
    function gameId(value){const n=String(value||'pokemon').toLowerCase().replace(/[^a-z0-9]/g,'');if(n==='all')return'all';if(n.includes('pokemon'))return'pokemon';if(n==='mtg'||n.includes('magic'))return'magic';if(n.includes('yugi'))return'yugioh';if(n.includes('onepiece'))return'one-piece';if(n.includes('lorcana'))return'lorcana';if(n.includes('fleshandblood')||n==='fab')return'flesh-and-blood';return n;}
    function planFor(link){
      const url=new URL(link.href,location.href);if(url.origin!==location.origin)return null;
      const params=Object.fromEntries(url.searchParams),number=link.dataset.dexNumber;
      if(number)return {game:'pokemon',mode:'pokedex',pokemon:number};
      if(url.pathname.endsWith('/pages/binder'))return {...params,game:gameId(link.dataset.binderGameName||params.game)};
      if(url.pathname.endsWith('/pages/card-catalog'))return {game:'pokemon',mode:'sets',...params};
      return null;
    }
    on(pane,'click',event=>{
      if(event.button||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
      const link=event.target.closest('a[href]'),summary=event.target.closest('summary');let plan=link?planFor(link):null;
      if(summary&&!summary.parentElement.open){const branch=summary.parentElement,key=branch.dataset.catalogBranch||'';if(branch.dataset.cardSetId)plan={game:'pokemon',mode:'sets',set:branch.dataset.cardSetId};else if(key.startsWith('db-series-'))plan={game:'pokemon',mode:'sets',series:key.slice(10)};else if(key.startsWith('dex-gen-'))plan={game:'pokemon',mode:'pokedex',generation:key.slice(8)};}
      if(!plan)return;
      if(link){const url=new URL('/pages/binder',location.origin);url.search=new URLSearchParams(plan);link.href=url.href;}
      if(!document.querySelector('[data-binder-view]'))return;
      if(link)event.preventDefault();
      pane.querySelectorAll('[aria-current]').forEach(el=>el.removeAttribute('aria-current'));if(link)link.setAttribute('aria-current','true');
      if(mobile.matches&&link)setOpen(false);
      document.dispatchEvent(new CustomEvent('killin:binder-navigate',{detail:plan}));
    });
    on(document,'visitorConsentCollected',reportExposure);
    on(document,'killin:analytics-ready',reportExposure);
    on(document,'visibilitychange',reportExposure);
    on(window,'pageshow',reportExposure);
    const resize = () => {showControl();setOpen(false, false);};
    mobile.addEventListener('change',resize); setOpen(false,false);
    dispose = () => { controller.abort(); mobile.removeEventListener('change',resize); body.inert = false; document.documentElement.classList.remove('catalog-open'); };
  }
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
